import { Template } from '@angular/compiler/src/render3/r3_ast';
import { Component, OnInit, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/app.reducer';
import { TemplateEnum } from 'src/app/core/enums/template.enum';
import { getThemeId } from '../../selectors/branding.selector';

@Component({
    selector: 'app-icon-cart-empty',
    templateUrl: './icon-cart-empty.component.html',
    styleUrls: ['./icon-cart-empty.component.scss']
})
export class IconCartEmptyComponent implements OnInit {
    template$: Observable<TemplateEnum>;
    templateEnum = TemplateEnum;

    @Input() cssClass = '';

    constructor(private store: Store<AppState>) { }

    ngOnInit() {
        this.template$ = this.store.select(getThemeId);
    }

}
